'use client';

import { c as _c } from "react/compiler-runtime";
import { motion } from 'framer-motion';
import { useState } from 'react';
interface StickyNoteProps {
  id: string;
  type: 'DONE' | 'IN_PROGRESS' | 'BACKLOG';
  title: string;
  content: string;
  color: string;
  initialX: number;
  initialY: number;
  rotation: number;
  badge?: string;
  stamp?: string;
}
export default function StickyNote(t0) {
  const $ = _c(44);
  const {
    id,
    type,
    title,
    content,
    color,
    rotation,
    badge,
    stamp
  } = t0;
  const [isDragging, setIsDragging] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  let t1;
  if ($[0] !== type) {
    t1 = () => {
      switch (type) {
        case "DONE":
          {
            return "\u2705";
          }
        case "IN_PROGRESS":
          {
            return "\uD83D\uDEA7";
          }
        case "BACKLOG":
          {
            return "\uD83D\uDCCB";
          }
        default:
          {
            return "";
          }
      }
    };
    $[0] = type;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const getStatusIcon = t1;
  let t2;
  if ($[2] !== color || $[3] !== rotation) {
    t2 = {
      backgroundColor: color,
      rotate: rotation
    };
    $[2] = color;
    $[3] = rotation;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== rotation) {
    t3 = {
      opacity: 0,
      scale: 0,
      rotate: rotation
    };
    $[5] = rotation;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const t4 = isDragging || isHovered ? 1.05 : 1;
  let t5;
  if ($[7] !== rotation || $[8] !== t4) {
    t5 = {
      opacity: 1,
      scale: t4,
      rotate: rotation
    };
    $[7] = rotation;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  let t7;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      scale: 1.05,
      zIndex: 1000
    };
    t7 = {
      scale: 1.1,
      zIndex: 1000,
      boxShadow: "0 20px 40px rgba(0, 0, 0, 0.3)"
    };
    $[10] = t6;
    $[11] = t7;
  } else {
    t6 = $[10];
    t7 = $[11];
  }
  let t8;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      left: -50,
      right: 50,
      top: -50,
      bottom: 50
    };
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t10;
  let t11;
  let t12;
  let t13;
  let t9;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = () => setIsDragging(true);
    t10 = () => setIsDragging(false);
    t11 = () => setIsHovered(true);
    t12 = () => setIsHovered(false);
    t13 = {
      type: "spring",
      stiffness: 300,
      damping: 30
    };
    $[13] = t10;
    $[14] = t11;
    $[15] = t12;
    $[16] = t13;
    $[17] = t9;
  } else {
    t10 = $[13];
    t11 = $[14];
    t12 = $[15];
    t13 = $[16];
    t9 = $[17];
  }
  let t14;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <div className="pm-sticky-pin" />;
    $[18] = t14;
  } else {
    t14 = $[18];
  }
  const t15 = getStatusIcon();
  let t16;
  if ($[19] !== t15) {
    t16 = <div className="pm-sticky-status-icon">{t15}</div>;
    $[19] = t15;
    $[20] = t16;
  } else {
    t16 = $[20];
  }
  let t17;
  if ($[21] !== title) {
    t17 = <div className="pm-sticky-title">{title}</div>;
    $[21] = title;
    $[22] = t17;
  } else {
    t17 = $[22];
  }
  let t18;
  if ($[23] !== content) {
    t18 = <div className="pm-sticky-content">{content}</div>;
    $[23] = content;
    $[24] = t18;
  } else {
    t18 = $[24];
  }
  let t19;
  if ($[25] !== badge) {
    t19 = badge && <div className="pm-sticky-badge">{badge}</div>;
    $[25] = badge;
    $[26] = t19;
  } else {
    t19 = $[26];
  }
  let t20;
  if ($[27] !== stamp || $[28] !== type) {
    t20 = stamp && type === "DONE" && <div className="pm-stamp-done">{stamp}</div>;
    $[27] = stamp;
    $[28] = type;
    $[29] = t20;
  } else {
    t20 = $[29];
  }
  let t21;
  if ($[30] !== type) {
    t21 = type === "IN_PROGRESS" && <div className="pm-sticky-loading"><motion.div animate={{
        rotate: 360
      }} transition={{
        duration: 2,
        repeat: Infinity,
        ease: "linear"
      }}>🔄</motion.div></div>;
    $[30] = type;
    $[31] = t21;
  } else {
    t21 = $[31];
  }
  let t22;
  if ($[32] !== id || $[33] !== t16 || $[34] !== t17 || $[35] !== t18 || $[36] !== t19 || $[37] !== t2 || $[38] !== t20 || $[39] !== t21 || $[40] !== t3 || $[41] !== t5 || $[42] !== type) {
    t22 = <motion.div className="pm-sticky-note" style={t2} initial={t3} animate={t5} whileHover={t6} whileDrag={t7} drag={true} dragConstraints={t8} dragElastic={0.2} onDragStart={t9} onDragEnd={t10} onHoverStart={t11} onHoverEnd={t12} transition={t13} data-note-id={id} data-note-type={type}>{t14}{t16}{t17}{t18}{t19}{t20}{t21}</motion.div>;
    $[32] = id;
    $[33] = t16;
    $[34] = t17;
    $[35] = t18;
    $[36] = t19;
    $[37] = t2;
    $[38] = t20;
    $[39] = t21;
    $[40] = t3;
    $[41] = t5;
    $[42] = type;
    $[43] = t22;
  } else {
    t22 = $[43];
  }
  return t22;
}